import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Label, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { ServiceThreadSpinner } from '.';
import { api } from '../utils';

export default function ManageDoublerDefaults() {
   const [model, setDefaults] = useState({});
   const [spin, setSpinner] = useState(true);
   const disabled = JSON.stringify(model) === "{}";

   useEffect(() => {
      GetDoublerDefaults();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function GetDoublerDefaults() {
      setSpinner(true);
      api
         .fetch(`Engineering/GetDoublerDefaults`)
         .then((response) => {
            if (response?.data) {
               if (response.data.success) {
                  setDefaults(response.data.defaults);
               } else {
                  toast.error(response.data.message);
               }
            }
            else {
               toast.error("Unable to retrieve default values!");
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   const handleFocus = (event) => event.target.select();

   function onChange(field, value) {
      if (field === "baseYarn" && value > 99999) {
         toast.warn("Base yarn cannot exceed 5 digits");
         return;
      }
      if (field === "ply" && value > 99) {
         toast.warn("Ply cannot exceed 2 digits");
         return;
      }
      if (field === "speed" && value > 99999) {
         toast.warn("Speed cannot exceed 5 digits");
         return;
      }
      if (field === "spindles" && value > 999) {
         toast.warn("Spindles cannot exceed 3 digits");
         return;
      }

      let changes = Object.assign({}, model);
      changes[field] = value;
      setDefaults(changes);
   }

   function SaveDefaults() {
      if (disabled) {
         toast.error("Missing Defaults!");
         return;
      }

      if (model?.baseYarn < 1) {
         toast.warn("Base yarn is required");
         return;
      }
      if (model?.ply < 1) {
         toast.warn("Ply is required");
         return;
      }
      if (model?.speed < 1) {
         toast.warn("Speed YPM is required");
         return;
      }
      if (model?.efficiency <= 0) {
         toast.warn("Efficiency is required");
         return;
      }
      if (model?.efficiency > 1) {
         toast.warn("Efficiency cannot exceed 100%");
         return;
      }
      if (model?.spindles < 1) {
         toast.warn("Number of spindles is required");
         return;
      }

      setSpinner(true);
      api.post(`Engineering/SaveDoublerDefaults`, model)
         .then((response) => {
            if (response.data.success) {
               toast.success("Doubler calculation defaults updated!")
            } else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinner(false);
         })
         .finally(() => {
            setSpinner(false);
         });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spin}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Label className="noWrap h5">Change one or more default values below and click the Save Defaults button</Label>
                           <br />
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6 width135px">
                                       Base Yarn:
                                    </td>
                                    <td className="transparent-background width135px">
                                       <Input
                                          type="number"
                                          name="baseYarn"
                                          value={model?.baseYarn || "0"}
                                          className="h-100 py-1 no-spinner"
                                          onChange={(e) => { onChange("baseYarn", e.target.value) }}
                                          maxLength={5}
                                          max={99999}
                                          min={1}
                                          onFocus={handleFocus}
                                       />
                                    </td>
                                    <td className="transparent-background width70px"></td>
                                    <td className="transparent-background data-cell noWrap h6 width115px">
                                       Ply:
                                    </td>
                                    <td className="transparent-background width135px">
                                       <Input
                                          type="number"
                                          name="ply"
                                          value={model?.ply || "0"}
                                          className="h-100 py-1 no-spinner"
                                          onChange={(e) => { onChange("ply", e.target.value) }}
                                          maxLength={2}
                                          max={99}
                                          min={1}
                                          onFocus={handleFocus}
                                       />
                                    </td>
                                    <td className="transparent-background width70px"></td>
                                    <td className="transparent-background data-cell noWrap h6 width135px">
                                       Speed (YPM):
                                    </td>
                                    <td className="transparent-background width135px">
                                       <Input
                                          type="number"
                                          name="speed"
                                          value={model?.speed || "0"}
                                          className="h-100 py-1 no-spinner"
                                          onChange={(e) => { onChange("speed", e.target.value) }}
                                          maxLength={5}
                                          max={99999}
                                          min={1}
                                          onFocus={handleFocus}
                                       />
                                    </td>
                                    <td className="transparent-background"></td>
                                 </tr>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6 width135px">
                                       Efficiency (%):
                                    </td>
                                    <td className="transparent-background width135px">
                                       <Input
                                          type="number"
                                          name="efficiency"
                                          value={model?.efficiency || "0"}
                                          className="h-100 py-1 no-spinner"
                                          onChange={(e) => { onChange("efficiency", e.target.value) }}
                                          maxLength={4}
                                          max={1.00}
                                          min={0.10}
                                          onFocus={handleFocus}
                                       />
                                    </td>
                                    <td className="transparent-background width70px"></td>
                                    <td className="transparent-background data-cell noWrap h6 width115px">
                                       # Spindles:
                                    </td>
                                    <td className="transparent-background width135px">
                                       <Input
                                          type="number"
                                          name="spindles"
                                          value={model?.spindles || "0"}
                                          className="h-100 py-1 no-spinner"
                                          onChange={(e) => { onChange("spindles", e.target.value) }}
                                          maxLength={3}
                                          max={999}
                                          min={1}
                                          onFocus={handleFocus}
                                       />
                                    </td>
                                    <td className="transparent-background width70px"></td>
                                    <td colSpan={2} className="transparent-background">
                                       <Button title="Save"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveDefaults()}
                                          disabled={disabled}>
                                          Save Defaults
                                       </Button>
                                    </td>
                                    <td colSpan={2} className="transparent-background"></td>
                                 </tr>
                              </tbody>
                           </Table>
                           <br /><br />
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
